import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { BASE_URL } from '../../../constant/api';

const ProductList = ({ product }) => {
    const [category, setCategory] = useState(null);

    useEffect(() => {
        // Fetch category data based on product category ID
        const fetchCategory = async () => {
            try {
                const response = await axios.get(`${BASE_URL}/categories/${product.category}/`);
                if (response.data && response.data.Data.length > 0) {
                    setCategory(response.data.Data[0].name); // Accessing the category name
                }
            } catch (error) {
                console.error('Error fetching category:', error);
            }
        };

        // Only fetch category if product.category exists
        if (product && product.category) {
            fetchCategory();
        }
    }, [product]);

    return (
        <div className="flex items-center space-x-4 p-2 bg-gray-100 rounded-md shadow-sm">
            <img
                src={
                    product.product_images && product.product_images[0]
                        ? (product.product_images[0].image.includes(BASE_URL)
                            ? product.product_images[0].image
                            : `${BASE_URL}${product.product_images[0].image}`)
                        : "/images/default-product.png"
                }
                alt={product.name || "Product"}
                className="w-10 h-10 object-cover rounded-lg"
            />
            <div className="text-gray-700">
                <div className="font-semibold">{product.name}</div>
                <div className="text-xs text-gray-500">Category: {category || 'N/A'}</div>
            </div>
        </div>
    );
};

export default ProductList;
